import { computed } from 'vue'

import { useUserStore } from './useUserStore'

export const useStaffPermissions = () => {
  const { user, isUserAuthenticatedStaff } = useUserStore()

  // avoid using this, use a specific permission getter instead
  const permissions = computed(() => {
    return user.value.permissions
  })

  const isUserAuthenticatedDexAgent = computed(() => {
    return permissions.value.includes('group-dex-bpo-agents')
  })

  const isUserAuthenticatedFraudLogisticsAgent = computed(() => {
    return permissions.value.includes('group-fraud-logistics-bpo-agents')
  })

  const isUserCareBpo = computed(() => {
    return (
      permissions.value.includes('group-care-bpo-agents') ||
      permissions.value.includes('group-care-bpo-agents-plus') ||
      permissions.value.includes('group-care-bpo-supervisors')
    )
  })

  const canViewCustomers = computed(() => {
    return (
      permissions.value.includes('view-customers') ||
      isUserAuthenticatedStaff.value
    )
  })

  const canAccessCustomerLifecyle = computed(() => {
    return permissions.value.includes('group-customer-lifecycle-managers')
  })

  const canImpersonateSeller = computed(() => {
    return permissions.value.includes('permission-impersonate-sellers')
  })

  const canAccessGdpr = computed(() => {
    return permissions.value.includes('group-identity-gdpr-access')
  })

  const canBulkResetPassword = computed(() => {
    return permissions.value.includes('group-users-security-managers')
  })

  const canViewPromotionCodes = computed(() =>
    permissions.value.includes('group-view-promotion-codes'),
  )

  const canCreatePromotionCodes = computed(() =>
    permissions.value.includes('group-create-promotion-codes'),
  )

  const canAdminPromotionCodes = computed(() =>
    permissions.value.includes('group-admin-promotion-codes'),
  )

  const canAccessPiiArchives = computed(() => {
    return permissions.value.includes('group-pii-archive')
  })

  const canManageCareTemplates = computed(() => {
    return permissions.value.includes('group-care-template-management')
  })

  const canViewUsers = computed(() => {
    return permissions.value.includes('group-view-users')
  })

  const canDisableUser2fa = computed(() => {
    return permissions.value.includes('permission-disable-users-2fa')
  })

  const canManageLegalOptout = computed(() => {
    return permissions.value.includes('group-manage-legal-optout')
  })

  const canAccessCmsContent = computed(() => {
    return permissions.value.includes('group-customer-content-admin-read')
  })

  const canViewProductDetailConfigurator = computed(() => {
    return permissions.value.includes('group-bo-staff-product')
  })

  const canCreateHelpRequestContacts = computed(() => {
    return permissions.value.includes('permission-create-help-request-contacts')
  })

  const isUserOktaAuthenticated = computed(() => {
    return !!user.value.bmUserId && permissions.value.length > 0
  })

  return {
    permissions,
    isUserAuthenticatedDexAgent,
    isUserAuthenticatedFraudLogisticsAgent,
    isUserCareBpo,
    canViewCustomers,
    canAccessCustomerLifecyle,
    canImpersonateSeller,
    canAccessGdpr,
    canBulkResetPassword,
    canViewPromotionCodes,
    canCreatePromotionCodes,
    canAdminPromotionCodes,
    canAccessPiiArchives,
    canManageCareTemplates,
    canViewUsers,
    canDisableUser2fa,
    canManageLegalOptout,
    canAccessCmsContent,
    canViewProductDetailConfigurator,
    canCreateHelpRequestContacts,
    isUserOktaAuthenticated,
  }
}
